import React from 'react';
import Image from 'next/image';
import '../styles/ReviewCard.css';

type StarRatingProps = {
  rating: number,
}

/**
 * A helper component to render the star rating.
 * It displays 5 stars, filling them in based on the rating prop.
 */
const StarRating = ({ rating }: StarRatingProps) => {
  const stars = [];
  for (let i = 0; i < rating; i++) {
    // A simple way to render filled stars up to the rating number
    stars.push(<span key={i}>★</span>);
  }
  return <div className="text-yellow-500">{stars}</div>;
};

type ReviewProps = {
  avatarUrl: string,
  name: string,
  rating: number,
  date: string,
  reviewText: string,
}


/**
 * The main ReviewCard component.
 * It structures a single review entry.
 */
const ReviewCard = ({ avatarUrl, name, rating, date, reviewText }: ReviewProps) => {
  return (
    <div className="review-card bg-gray-800 rounded-xl p-6 shadow-lg flex flex-col gap-4">
      <div className="review-header flex items-center gap-4">
        <Image src={avatarUrl} alt={`${name}'s avatar`} width={48} height={48} className="avatar w-12 h-12 rounded-full" />
        <div className="user-info">
          <p className="user-name font-bold">{name}</p>
        </div>
      </div>
      <div className="review-meta flex items-center gap-2 text-sm text-gray-400">
        <StarRating rating={rating} />
        <span className="meta-dot">·</span>
        <span className="review-date">{date}</span>
      </div>
      <p className="review-body text-gray-300">{reviewText}</p>
    </div>
  );
};

export default ReviewCard;